import React from "react";
import { useTranslate } from "@refinedev/core";
import { Modal, Flex, Typography, Switch, Button } from "antd";

interface OrderSettingsModalProps {
    open: boolean;
    onCancel: () => void;
    autoStartOrder: boolean;
    isSaving: boolean;
    onAutoStartChange: (value: boolean) => void;
    onSave: () => void;
}

export const OrderSettingsModal: React.FC<OrderSettingsModalProps> = ({
    open,
    onCancel,
    autoStartOrder,
    isSaving,
    onAutoStartChange,
    onSave,
}) => {
    const _t = useTranslate();

    return (
        <Modal
            title={_t("orders.settings.title")}
            open={open}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    {_t("buttons.cancel")}
                </Button>,
                <Button key="save" type="primary" loading={isSaving} onClick={onSave}>
                    {_t("orders.settings.save")}
                </Button>,
            ]}
        >
            <Flex vertical gap="middle" className="py-2">
                <Flex align="center" justify="space-between">
                    <Typography.Text>{_t("orders.settings.autoStartOrder")}</Typography.Text>
                    <Switch checked={autoStartOrder} onChange={onAutoStartChange} />
                </Flex>
            </Flex>
        </Modal>
    );
};
